import CurrentLocation from "./../PersonalInformation/CurrentLocation";
import SalaryCondition from "./SalaryCondition";

export default function SalaryPerLocation({
  viewMode,
  model,
  contractTypes,
  monetaryList,
  errors,
  setModel,
  index,
  deleteSalaryLocation
}) {

  function changeCurrentLocation(currentLocation) {
    setModel({ ...model, currentLocation: currentLocation });
  }

  return (
    <>
      <div>
        <div className="salary-info">
          <CurrentLocation
            currentLocation={model?.currentLocation || {}}
            setCurrentLocation={changeCurrentLocation}
            viewMode={viewMode}
          />
        </div>
        <SalaryCondition
          model={model}
          mainLabel={"Salary"}
          contractTypes={contractTypes}
          monetaryList={monetaryList}
          errors={errors}
          setModel={setModel}
          index={index}
          deleteSalaryLocation={deleteSalaryLocation}
        />
      </div>
    </>
  );
}